import { useLayoutEffect, useRef } from 'react'
import { isServer } from 'lib/utils'

const isBrowser = typeof window !== `undefined`

function getScrollPosition() {
  if (!isBrowser) return { x: 0, y: 0 }
  return { x: window.scrollX, y: window.scrollY }
}

type PositionProps = {
  x: number
  y: number
}

type UseScrollPositionProps = {
  useEffect: (currPos: PositionProps) => void
}

const useScrollPositionHook = ({ useEffect }: UseScrollPositionProps) => {
  const position = useRef(getScrollPosition())
  const wait = 500

  let throttleTimeout: ReturnType<typeof setTimeout> = null

  const useCallback = () => {
    const currPos = getScrollPosition()
    useEffect(currPos)
    position.current = currPos
    throttleTimeout = null
  }

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (throttleTimeout === null) {
        throttleTimeout = setTimeout(useCallback, wait)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const useScrollPosition = isServer() ? () => {} : useScrollPositionHook

export default useScrollPosition
